import yaml from 'js-yaml';

interface OpenAPISpec {
  openapi?: string;
  swagger?: string;
  [key: string]: unknown;
}

export const detectFileType = (filename: string, content: string) => {
  const ext = filename.split('.').pop()?.toLowerCase();
  
  // Check for markdown
  if (ext === 'md' || ext === 'markdown') {
    return 'markdown';
  }
  
  // Check for OpenAPI/Swagger specs
  if (['json', 'yaml', 'yml'].includes(ext ?? '')) {
    try {
      let parsed: OpenAPISpec;
      
      // Try to parse as JSON first
      try {
        parsed = JSON.parse(content) as OpenAPISpec;
      } catch {
        // If JSON parsing fails, try YAML
        parsed = yaml.load(content) as OpenAPISpec;
      }
      
      // Check if it's an OpenAPI/Swagger spec
      if (parsed && (parsed.openapi || parsed.swagger)) {
        return 'openapi';
      }
    } catch {
      // Not a valid JSON/YAML or not an OpenAPI spec
    }
  }
  
  // Default to code/text
  return 'code';
};

export const getFileIcon = (filename: string) => {
  const ext = filename.split('.').pop()?.toLowerCase();
  
  if (ext === 'md' || ext === 'markdown') return 'markdown';
  if (['json', 'yaml', 'yml'].includes(ext ?? '')) return 'code';
  if (['js', 'jsx', 'ts', 'tsx'].includes(ext ?? '')) return 'javascript';
  if (['py', 'python'].includes(ext ?? '')) return 'python';
  if (['rb', 'ruby'].includes(ext ?? '')) return 'ruby';
  if (['java', 'kt', 'kotlin'].includes(ext ?? '')) return 'java';
  if (['c', 'cpp', 'cc', 'h', 'hpp'].includes(ext ?? '')) return 'cpp';
  if (['css', 'scss', 'sass', 'less'].includes(ext ?? '')) return 'css';
  if (['html', 'htm', 'xml'].includes(ext ?? '')) return 'html';
  
  return 'file';
};